module.exports = __webpack_public_path__ + "static/img/logout.0df691cc.png";